type Length = 'narrow' | 'short' | 'long';
type Numerical = 'numeric' | '2-digit';

interface FormatMatcherInterface {
    weekday: Length;
    era: Length;
    year: Numerical;
    month: Numerical | Length;
    day: Numerical;
    hour: Numerical;
    minute: Numerical;
    second: Numerical;
    timeZoneName: 'short' | 'long';
}

export default function timeStamp(
    stamp: number,
    locale = 'pl-PL',
    options: Partial<FormatMatcherInterface> = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }
): string | null {
    return new Date(stamp * 1000).toLocaleDateString(locale, options);
}
